<!--
 * @Author: Ashley.Liu
 * @Date: 2022-07-11 17:36:08
 * @LastEditTime: 2022-07-11 17:48:39
 * @Description: desc
-->
<template>
  <div class="async-column-status-wrap">
    <!-- mode dot -->
    <template v-if="mode === Mode['dot']">
      <zm-tooltip
        :append-to-body="true"
        class="item"
        :content="content"
        placement="top"
      >
        <span :class="['dot-health', color]"></span>
      </zm-tooltip>
    </template>

    <!-- mode tab -->
    <template v-else>
      <zm-tooltip
        :append-to-body="true"
        class="item"
        :content="content"
        placement="top"
      >
        <span :class="['tab-health', color]">
          <span>{{ content }}</span>
        </span>
      </zm-tooltip>
    </template>
  </div>
</template>

<script>
const DotHealthColorMap = {
  success: 'dot-health-success',
  warning: 'dot-health-warning',
  error: 'dot-health-error',
  primary: 'dot-health-primary',
  info: 'dot-health-info',
}

const TabHealthColorMap = {
  success: 'tab-health-success',
  warning: 'tab-health-warning',
  error: 'tab-health-error',
  primary: 'tab-health-primary',
  info: 'tab-health-info',
}

const Mode = {
  dot: 'dot',
  tab: 'tab',
}

export default {
  name: 'AsStatus',
  props: {
    mode: {
      type: String,
      default: Mode.dot,
    },
    status: {
      type: String,
      default: '',
    },
    popoverText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      Mode,
    }
  },
  computed: {
    content() {
      return this.popoverText ? this.popoverText : this.status
    },
    color() {
      return this.mode === Mode.dot
        ? DotHealthColorMap[this.status]
        : TabHealthColorMap[this.status]
    },
  },
}
</script>

<style lang="scss" scoped>
.async-column-status-wrap {
  display: inline-flex;
}
@mixin dot-health {
  .dot-health {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    margin-top: 0;
  }

  .dot-health-error {
    background: #e8173d;
  }

  .dot-health-success {
    background: #66cc84;
  }

  .dot-health-primary {
    background: #3b90f7;
  }

  .dot-health-warning {
    background: #ffbf39;
  }

  .dot-health-info {
    background: #6e7680;
  }
}

@mixin tab-health {
  .tab-health {
    display: inline-flex;
    border-radius: 4px 8px;
    padding: 0 6px;
  }
  .tab-health-error {
    background: #fff2f5;
    color: #b10e2c;
    border: 1px solid #fad1d9;
  }

  .tab-health-success {
    background: #f2fff6;
    color: #17672f;
    border: 1px solid #c9e7d2;
  }

  .tab-health-primary {
    background: #f2f8ff;
    color: #0956b5;
    border: 1px solid #d0e3fb;
  }

  .tab-health-warning {
    background: #fff9f2;
    color: #894c01;
    border: 1px solid #f0dcc4;
  }

  .tab-health-info {
    background: #f7f9fa;
    color: #444b53;
    border: 1px solid #dfe3e8;
  }
}

@include dot-health;
@include tab-health;
</style>
